import {Platform} from 'react-native';
import {createNavigationContainerRef} from '@react-navigation/native';
import {StackActions} from '@react-navigation/native';
import {
  redirectToH5MigrationTarget,
  shouldRedirectForH5Migration,
} from '@/utils/h5-migration';

export const navigationRef = createNavigationContainerRef();

const isReady = () => navigationRef.isReady();

export function navigate(name, params) {
  if (Platform.OS === 'web' && shouldRedirectForH5Migration(name, params)) {
    redirectToH5MigrationTarget();
    return;
  }
  isReady() && navigationRef.navigate(name, params);
}

export function replace(name, params) {
  if (Platform.OS === 'web' && shouldRedirectForH5Migration(name, params)) {
    redirectToH5MigrationTarget();
    return;
  }
  isReady() && navigationRef.dispatch(StackActions.replace(name, params));
}

export function navGoBack() {
  if (
    Platform.OS === 'web' &&
    navigationRef.current.getState().routes.length < 2
  ) {
    window.history.back();
  } else {
    navigationRef.goBack();
  }
}
